import { supabase } from '../supabase/client'
import type { ConnectivityState } from './types'

let lastProbe: { state: ConnectivityState; at: number } | null = null
let activeProbe: Promise<ConnectivityState> | null = null

export async function probeConnectivity(): Promise<ConnectivityState> {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    lastProbe = { state: 'OFFLINE', at: Date.now() }
    return 'OFFLINE'
  }
  if (lastProbe && Date.now() - lastProbe.at < 5_000) return lastProbe.state
  if (activeProbe) return activeProbe
  activeProbe = runProbe().finally(() => { activeProbe = null })
  return activeProbe
}

async function runProbe(): Promise<ConnectivityState> {
  let state: ConnectivityState
  try {
    const probe = supabase.from('profiles').select('id').limit(1)
    const result = await Promise.race([
      probe,
      new Promise<never>((_, reject) => setTimeout(() => reject(new Error('timeout')), 3_000)),
    ])
    state = result.error ? 'DEGRADED' : 'ONLINE'
  } catch {
    state = 'DEGRADED'
  }
  lastProbe = { state, at: Date.now() }
  return state
}

export async function backendCanBeReached(): Promise<boolean> {
  return (await probeConnectivity()) === 'ONLINE'
}
